var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgReport(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.1607 6.76243L14.7404 7.7162M10.3934 9.61007L12.1832 10.0869M10.4824 14.9748L11.1983 15.1656C13.2233 15.7051 14.2358 15.9749 15.0334 15.517C15.831 15.0591 16.1024 14.0523 16.6449 12.0387L17.4122 9.19112C17.9549 7.17755 18.2262 6.17077 17.7656 5.37763C17.3051 4.58448 16.2926 4.31472 14.2676 3.77519L13.5517 3.58443C11.5268 3.04489 10.5143 2.77513 9.71663 3.23306C8.91897 3.69098 8.64767 4.69776 8.10508 6.71132L7.33774 9.55892C6.79514 11.5725 6.52385 12.5793 6.98437 13.3724C7.44488 14.1656 8.45738 14.4354 10.4824 14.9748Z",
    stroke: "#64748B",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5 17.2097L9.78577 17.4042C7.76551 17.9543 6.7554 18.2293 5.95963 17.7624C5.16386 17.2956 4.8932 16.269 4.35188 14.216L3.58635 11.3125C3.04502 9.25945 2.77436 8.23291 3.23381 7.42421C3.63123 6.72466 4.49998 6.75013 5.62499 6.75004",
    stroke: "#64748B",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReport);
export default __webpack_public_path__ + "static/media/report.0cec174fd98df1017a788adf91640ae4.svg";
export { ForwardRef as ReactComponent };